var pug = require("!../../../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cemployee-calculations-component options=\"{'is_berater_view': true, 'valuenet_id': berater.vbmData.employeeId}\"\u003E\u003C\u002Femployee-calculations-component\u003E";;return pug_html;};
module.exports = template;